import logo from './logo.png'
import iconUpload from './icon-upload.png'
import iconClose from './icon-close.png'
import emptyAvatar from './emptyAvatar.png'
import loginImage from './Mobile login-bro.png'

export default {
    logo ,iconUpload,iconClose,emptyAvatar,loginImage

}